(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/tipsinfo/javascripts/tipsinfo.js') >= 0) return;  svs.modules.push('/components/sport/tipsinfo/javascripts/tipsinfo.js');

'use strict';

(function (svs, React) {
  class Tipsinfo extends React.Component {
    componentDidMount() {
      const escHandler = {
        callback: () => {
          this.props.closeTipsinfo();
          return true;
        }
      };
      svs.components.Modal.show(React.createElement(svs.components.ReactSwiper, null, React.createElement(svs.sport.tipsinfo.TipsinfoModalContent, this.props)), {
        escHandler
      }, {
        headerClass: this.props.modalHeaderClass,
        title: 'TIPSINFO',
        onHideByBrowserBack: this.props.closeTipsinfo,
        dontPushModalToHistory: !svs.core.detect.formfactor.mobile(),
        leftButton: {
          visible: false
        },
        rightButton: {
          text: 'Klar',
          cssClass: 'btn-transparent-inverted',
          callback: () => {
            this.props.closeTipsinfo();
            return true;
          }
        }
      });
    }
    componentWillUnmount() {
      svs.components.Modal.escHandler = undefined;
    }
    render() {
      return null;
    }
  }
  Tipsinfo.defaultProps = {
    modalHeaderClass: ''
  };
  svs.sport.tipsinfo.Tipsinfo = Tipsinfo;
})(svs, React);

 })(window);